import { FlexLayout, H4, Icon } from '@deity/falcon-ui';
import type { FC } from 'react';
import { Link } from 'react-router-dom';

interface ModelInfoProps {
  name: string;
  fieldCount: number;
  requiredFields: number;

  packageUuid?: string;
  packageVersionUuid?: string;
  uuid?: string;
  validation?: {
    valid: boolean;
    messages: Array<{ message: string; type: string }>;
  };
}
export const ModelInfo: FC<ModelInfoProps> = ({
  name,
  fieldCount,
  requiredFields,
  packageUuid,
  packageVersionUuid,
  uuid,
  validation
}) => {
  const isValid = validation?.valid === undefined ? true : validation?.valid;
  const errorCounts = { errors: 0, warnings: 0 };
  if (validation) {
    validation.messages?.reduce((acc, item) => {
      if (item.type === 'error') {
        acc.errors += 1;
      } else if (item.type === 'warning') {
        acc.warnings += 1;
      }

      return acc;
    }, errorCounts);
  }

  return (
    <FlexLayout p="md" bg="lightGrey" borderRadius="small" flexDirection="column" css={{ minWidth: '200px' }}>
      <H4 fontWeight="semiBold" fontSize="lg">
        {name}
        {packageVersionUuid && uuid && packageUuid && (
          <Link to={`/packages/${packageUuid}/${packageVersionUuid}/structures/${uuid}`}>
            <Icon src="openInNew" color="secondary" stroke="transparent" />
          </Link>
        )}
      </H4>
      <H4 mt="md" color="secondary" fontWeight="bold">
        {fieldCount} FIELDS
      </H4>
      <H4 color="secondary">{requiredFields} Required</H4>
      {(!isValid || errorCounts.errors > 0 || errorCounts.warnings > 0) && (
        <FlexLayout alignItems="center" flexWrap="nowrap" mt="xl" css={{ position: 'absolute', bottom: -50 }}>
          <Icon
            src={isValid ? 'warningOutlined' : 'error'}
            color="transparent"
            stroke={isValid ? 'warningDark' : 'error'}
            mr="xs"
          />
          <H4 fontSize="sm" color="warningDark">
            {`This model ${isValid ? '' : 'is Invalid. And'} has ${errorCounts.errors} errors ${errorCounts.warnings} warnings `}
          </H4>
        </FlexLayout>
      )}
    </FlexLayout>
  );
};
